export default "__VITE_ASSET__eB3kY1gB__"